import { NotFoundScreen } from '@todo/web-ui/components/not-found-screen';

// Client-side fallback for a URL no route matches. The exported 404.html comes
// from the [lang] layout instead (see its comment) — the same screen.
export default function NotFound() {
  return <NotFoundScreen />;
}
